import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../../../../assets/images/Gato-logo.svg";
import { IsAuthenticated } from "helpers";
import { Logout } from "api-services";
import "./public-docs-navbar.css";

const navItems = [
  { name: "Account Opening API", path: "/" },
  { name: "Funding API", path: "/docs/funding" },
  { name: "Trading API", path: "/docs/trading" },
  { name: "Fix Specification", path: "/docs/fix" },
  { name: "Corporate Actions API", path: "/docs/corporate-actions-api" },
  { name: "Risk & Margin API", path: "/docs/risk-margin-api" },
];

function PublicDocsNavbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { user_data } = useSelector((state) => state.authentication);
  const isAuthenticated = IsAuthenticated();
  const fullName = user_data?.customer?.fullName;
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => pathname === path;

  return (
    <header className="pdn-wrap">
      <div className="pdn-inner">
        <a href={window.globalConfig?.mainWebsiteUrl || "/"} className="pdn-brand">
          <img src={Logo} alt="Gato" />
        </a>

        <div className="pdn-divider pdn-divider--desktop" />

        <nav className="pdn-links pdn-links--desktop">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`pdn-link ${isActive(item.path) ? "pdn-link--active" : ""}`}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        <div className="pdn-actions pdn-actions--desktop">
          {isAuthenticated ? (
            <>
              <button type="button" className="pdn-user" onClick={() => navigate("/dashboard")}>
                <AccountCircleIcon fontSize="small" className="me-1" />
                <span>{fullName || "Dashboard"}</span>
              </button>
              <button
                type="button"
                className="pdn-btn pdn-btn--primary"
                onClick={() => Logout(dispatch, navigate)}
              >
                Sign Out
              </button>
            </>
          ) : (
            <>
              {/* <button
                type="button"
                className="pdn-signin"
                onClick={() => navigate("/authentication/sign-in")}
              >
                Sign In
              </button>
              <button
                type="button"
                className="pdn-btn pdn-btn--primary"
                onClick={() => navigate("/authentication/sign-up")}
              >
                Request API Access
              </button> */}
            </>
          )}
        </div>

        <button
          className="pdn-hamburger"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>
      </div>

      {menuOpen && (
        <div className="pdn-mobile-menu">
          <nav className="pdn-mobile-links">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`pdn-mobile-link ${isActive(item.path) ? "pdn-link--active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </nav>
          <div className="pdn-mobile-actions">
            {isAuthenticated ? (
              <>
                <button
                  type="button"
                  className="pdn-mobile-user"
                  onClick={() => { navigate("/dashboard"); setMenuOpen(false); }}
                >
                  <AccountCircleIcon fontSize="small" className="me-1" />
                  <span>{fullName || "Dashboard"}</span>
                </button>
                <button
                  type="button"
                  className="pdn-btn pdn-btn--primary"
                  onClick={() => { Logout(dispatch, navigate); setMenuOpen(false); }}
                >
                  Sign Out
                </button>
              </>
            ) : (
              <>
                {/* <button
                  type="button"
                  className="pdn-signin"
                  onClick={() => { navigate("/authentication/sign-in"); setMenuOpen(false); }}
                >
                  Sign In
                </button>
                <button
                  type="button"
                  className="pdn-btn pdn-btn--primary"
                  onClick={() => { navigate("/authentication/sign-up"); setMenuOpen(false); }}
                >
                  Request API Access
                </button> */}
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}

export default PublicDocsNavbar;
